



















import { defineComponent } from '@vue/composition-api';
import Vue from 'vue';

import OddButton from './OddButton.vue';

export default defineComponent({
    name: 'Pick',
    inheritAttrs: false,
    functional: true,
    props: {
        id: {
            type: Number,
            required: true,
        },
        uuid: {
            type: String,
            required: true,
        },
        value: {
            type: Number,
            required: false,
            default: null,
        },
        displayValue: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        isLocked: {
            type: Boolean,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        marketName: {
            type: String,
            default: '',
        },
        isEventLocked: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false,
        },
        valueChangeDynamics: {
            type: Object,
            required: false,
            default: null,
        },
        isRefund: {
            type: Boolean,
            required: false,
            default: false,
        },
        tooltipDescription: {
            type: String,
            required: false,
            default: '',
        },
        status: {
            type: String,
            required: false,
            default: '',
        },
        components: {
            type: Object,
            default() {
                return {
                    OddButton,
                };
            },
        },
    },
    methods: {
        format(value?: number) {
            return value
                ? Vue.prototype.$formatOddValue(value)
                : null;
        },
    },
});
